export default "__VITE_ASSET__e891797d__"